/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
} from './DayOfWeek';
import type { ScheduledDowntimeKind } from './ScheduledDowntimeKind';
import {
    ScheduledDowntimeKindFromJSON,
    ScheduledDowntimeKindFromJSONTyped,
    ScheduledDowntimeKindToJSON,
} from './ScheduledDowntimeKind';

/**
 * 
 * @export
 * @interface ScheduledDowntimeUpsertRequest
 */
export interface ScheduledDowntimeUpsertRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    reason: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    endsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    startsAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    endTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    startTime?: string | null;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    daysOfWeek?: Array<DayOfWeek> | null;
    /**
     * 
     * @type {ScheduledDowntimeKind}
     * @memberof ScheduledDowntimeUpsertRequest
     */
    kind: ScheduledDowntimeKind;
}



/**
 * Check if a given object implements the ScheduledDowntimeUpsertRequest interface.
 */
export function instanceOfScheduledDowntimeUpsertRequest(value: object): value is ScheduledDowntimeUpsertRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function ScheduledDowntimeUpsertRequestFromJSON(json: any): ScheduledDowntimeUpsertRequest {
    return ScheduledDowntimeUpsertRequestFromJSONTyped(json, false);
}

export function ScheduledDowntimeUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledDowntimeUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
        'startsAt': json['startsAt'] == null ? undefined : (new Date(json['startsAt'])),
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'daysOfWeek': json['daysOfWeek'] == null ? undefined : ((json['daysOfWeek'] as Array<any>).map(DayOfWeekFromJSON)),
        'kind': ScheduledDowntimeKindFromJSON(json['kind']),
    };
}

export function ScheduledDowntimeUpsertRequestToJSON(value?: ScheduledDowntimeUpsertRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt'] as any).toISOString()),
        'startsAt': value['startsAt'] == null ? undefined : ((value['startsAt'] as any).toISOString()),
        'endTime': value['endTime'],
        'startTime': value['startTime'],
        'daysOfWeek': value['daysOfWeek'] == null ? undefined : ((value['daysOfWeek'] as Array<any>).map(DayOfWeekToJSON)),
        'kind': ScheduledDowntimeKindToJSON(value['kind']),
    };
}

